import { render, staticRenderFns } from "./PracticaIntro.vue?vue&type=template&id=341bae8d&"
import script from "./PracticaIntro.vue?vue&type=script&lang=js&"
export * from "./PracticaIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports